import React from 'react';
import PropTypes from 'prop-types';

const SchemeLandingBanner = ({
  title,
  description,
  primaryButtonText,
  primaryButtonAction,
  secondaryButtonText,
  secondaryButtonAction,
  bannerColor = '#1F1F1F',
  imageSrc,
  imageAlt = 'Banner Image'
}) => {
  return (
    <section
      className="relative flex rounded-xl mt-9 w-full overflow-hidden"
      style={{ backgroundColor: bannerColor }}
    >
      {/* Left side content */}
      <div className="flex flex-col px-3 py-3 text-white w-full sm:w-2/3 md:w-1/2">
        <h2 className="text-base md:text-xl font-medium">{title}</h2>
        <div className="w-full min-[1176px]:w-3/5">
          <p className="mt-3 text-[10px] min-[1176px]:text-xs mb-3 font-normal text-[#F1F1F1] max-w-md">
            {description}
          </p>
        </div>

        <div className="flex flex-row mt-auto gap-3 items-center sm:items-start">
          {/* Primary Button */}
          {primaryButtonText && primaryButtonAction && (
            <button
              onClick={primaryButtonAction}
              className="bg-white text-[#1F1F1F] text-[10px] min-[1176px]:text-[12px] px-3 sm:px-6 py-1 md:py-2 font-medium rounded-full flex items-center hover:bg-gray-100 transition-colors"
            >
              {primaryButtonText}
            </button>
          )}

          {/* Secondary Button */}
          {secondaryButtonText && secondaryButtonAction && (
            <button
              onClick={secondaryButtonAction}
              className="px-3 sm:px-4 py-1 md:py-2 text-[10px] min-[1176px]:text-[12px] text-white bg-transparent border border-white font-medium rounded-full hover:bg-white/10 transition-colors w-auto"
            >
              {secondaryButtonText}
            </button>
          )}
        </div>
      </div>

      {/* Right side - image */}
      {imageSrc && (
        <div className="min-[1176px]:flex min-[1176px]:w-3/5 justify-end hidden">
          <img src={imageSrc} alt={imageAlt} className="max-w-full h-auto object-contain" />
        </div>
      )}
    </section>
  );
};

SchemeLandingBanner.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  primaryButtonText: PropTypes.string,
  primaryButtonAction: PropTypes.func,
  secondaryButtonText: PropTypes.string,
  secondaryButtonAction: PropTypes.func,
  bannerColor: PropTypes.string,
  imageSrc: PropTypes.string,
  imageAlt: PropTypes.string
};

export default SchemeLandingBanner;
